import { style } from "@vanilla-extract/css";
import { vars } from "../../styles/theme.css";

export const addIcon = style({
  transition: "transform 0.2s ease-in-out",
  margin: 2,
  width: 10,
  height: 10,
  fill: vars.colors.primary,
});

export const removeIcon = style([
  addIcon,
  {
    transform: "rotate(45deg)",
  },
]);
